import React from 'react'
import { useLocation } from 'react-router-dom'

import { dponet } from 'service'
import serverError from 'helpers/serverError'
import UnexpectedError from './UnexpectedError'

const ServerError = () => {
  const location = useLocation()

  const { eventId, occurredAt, previousPath } = serverError.parseSearch(
    location.search,
  )

  const userId = dponet.auth.isAuthenticated()
    ? dponet.auth.getUserIdFromToken()
    : undefined
  const companyId = dponet.auth.getCompany() || undefined

  return (
    <UnexpectedError
      eventId={eventId}
      userId={userId}
      companyId={companyId}
      previousPage={previousPath || document.referrer || undefined}
      occurredAt={occurredAt ? new Date(occurredAt) : undefined}
    />
  )
}

export default ServerError
